import script from "./InternetFinance.vue?vue&type=script&setup=true&lang=js"
export * from "./InternetFinance.vue?vue&type=script&setup=true&lang=js"

import "./InternetFinance.vue?vue&type=style&index=0&id=97636f86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97636f86"]])

export default __exports__